<app-hero-banner
  [title]="'creations'"
  [isFullBanner]="false"
  [imgPath]="'../../assets/hi-res/hero-half.JPG'"
></app-hero-banner>

<div class="container">
  <div class="page-tagline">
    <h2>Explore Our Creations Below</h2>
  </div>

  <div class="tools">
    <div class="filters">
      <span>Filter by:</span>

      <div class="radio-grid">
        <label class="radio">
          <input
            type="radio"
            [(ngModel)]="filters.selectedFilter"
            [value]="'mediaWalls'"
            (change)="applyFilter('mediaWalls')"
          />
          <div class="check"></div>
        </label>
        <span class="radio-label">Media Walls</span>
      </div>

      <div class="radio-grid">
        <label class="radio">
          <input
            type="radio"
            [(ngModel)]="filters.selectedFilter"
            [value]="'drinksBars'"
            (change)="applyFilter('drinksBars')"
          />
          <div class="check"></div>
        </label>
        <span class="radio-label">Drinks Bars</span>
      </div>

      <div class="radio-grid">
        <label class="radio">
          <input
            type="radio"
            [(ngModel)]="filters.selectedFilter"
            [value]="'offices'"
            (change)="applyFilter('offices')"
          />
          <div class="check"></div>
        </label>
        <span class="radio-label">Home Offices</span>
      </div>

      <div class="radio-grid">
        <label class="radio">
          <input
            type="radio"
            [(ngModel)]="filters.selectedFilter"
            [value]="'wardrobes'"
            (change)="applyFilter('wardrobes')"
          />
          <div class="check"></div>
        </label>
        <span class="radio-label">Wardrobes</span>
      </div>

      <div class="radio-grid">
        <label class="radio">
          <input
            type="radio"
            [(ngModel)]="filters.selectedFilter"
            [value]="'commercialSpaces'"
            (change)="applyFilter('commercialSpaces')"
          />
          <div class="check"></div>
        </label>
        <span class="radio-label">Commercial Spaces</span>
      </div>

      <!-- Clear Filter Button -->
      @if (this.filters.selectedFilter) {
      <button class="clear-filter" (click)="clearFilter()">Clear Filter</button>
      }
    </div>
  </div>

  <div class="creations-container">
    <!-- Filtered Tiles -->
    @if (filteredTiles.length > 0) { @for (tile of filteredTiles; track $index)
    {
    <div class="tile">
      <a (click)="openCarousel(tile.imageName, tile.imagePath)">
        <img [src]="getImageUrl(tile)" [alt]="tile.imageTitle[0]" />
      </a>
    </div>
    } } @if (filteredTiles.length === 0) {
    <div class="no-content-message">
      <i class="fa fa-exclamation-circle"></i>
      <!-- <h2>No {{ getFilterName(filters.selectedFilter) }} found</h2> -->
      <h2>No images found</h2>
      <p>Sorry, we couldn't find any content for the selected category.</p>

      <button (click)="clearFilter()">Clear Filter</button>
    </div>
    }
  </div>
</div>

<app-carousel [images]="selectedImages"></app-carousel>
